import { headerHeight } from "@public/js/components/header-height.js";
import { shallowRef } from "@vue/reactivity";
import { watch, watchEffect } from "vue";

export class HeaderModel {
    height = shallowRef(0);
    isSidebarOpen = shallowRef(false);

    changeHeight = (value: number) => {
        this.height.value = value;
    };

    toggleSidebar = (value = !this.isSidebarOpen.value) => {
        this.isSidebarOpen.value = value;
    };

    constructor() {
        watch(
            () => this.height.value,
            () => {
                headerHeight();
            },
        );
        watchEffect(() => {
            if (this.isSidebarOpen.value) {
                document.body.classList.add("menu-open");
            } else {
                document.body.classList.remove("menu-open");
            }
        });
    }
}

export const headerModel = new HeaderModel();
